@if (showCeReviewDetails) {
  <div class="card mt-1">
    <div class="card-body">
      <h4>CE Review Details</h4>
      @if (showClientPrescriberTask) {
        <app-ce-review-client-prescriber-task
          [clientPrescriberTask]="capture.clientPrescriberTask"
          />
      }
      @if (showClientReferralTask) {
        <app-ce-review-client-referral-task
          [clientReferralTask]="capture.clientReferralTask"
          [capture]="capture"
          />
      }
      @if (showClientConsultNoteTask) {
        <app-ce-review-client-consult-note-task
          [clientConsultNoteTask]="capture.clientConsultNoteTask"
          />
      }
    </div>
  </div>
}
